import React from 'react';
import { Box } from '@mui/material';

import Paper from 'components/paper';
import ScenarioPlanList from './scenario-plan-list';
import { ScenarioFishGroupsProvider, useScenarioFishGroupsState } from 'views/bluviu-nutrition/features/scenarios-v2/context/scenario-fish-groups-context';

interface ScenarioAppliedTabProps { }

const ScenarioApplied: React.FC<ScenarioAppliedTabProps> = ({ }) => {
  const { appliedScenarioQuery: { data: scenario } } = useScenarioFishGroupsState();

  return (
    <Box flexDirection={'column'} display={'flex'} gap={4}>
      <Paper sx={{ display: 'flex', flexDirection: 'column', alignContent: 'center', justifyContent: 'center' }}>
        {scenario && <ScenarioPlanList scenario={scenario} />}
      </Paper>
    </Box>
  );
};

const ScenarioAppliedTab: React.FC<ScenarioAppliedTabProps> = () => {
  return (
    <ScenarioFishGroupsProvider>
      <ScenarioApplied />
    </ScenarioFishGroupsProvider>

  );
}

export default React.memo(ScenarioAppliedTab);
